<template>
  <div :class="classes">
    <svg class="c-finish__icon" viewBox="0 0 50 50">
      <path
        fill="#FFD064"
        d="M19 25.9h-4.2c-1.7 0-3.5-.6-4.9-1.7L4.4 20A7.3 7.3 0 018.8 6.8h4.7l-.1 3.4H8.8a4 4 0 00-2.4 7.2l5.5 4.2c.8.6 1.9 1 3 1H19v3.3z"
      />
      <path
        fill="#ECBE6B"
        d="M10 22.5l-5.6-4.2a7.3 7.3 0 01-2.9-5c-.3 2.6.8 5.1 3 6.7l5.4 4.2c1.4 1 3.2 1.7 5 1.7H19V24h-4.2c-1.7 0-3.5-.6-4.9-1.6z"
      />
      <path
        fill="#FFD064"
        d="M31 25.9h4.2c1.7 0 3.5-.6 4.9-1.7l5.5-4.2a7.3 7.3 0 00-4.4-13.2h-4.7l.2 3.4h4.5a4 4 0 012.4 7.2l-5.5 4.2c-.8.6-1.9 1-3 1H31v3.3z"
      />
      <path
        fill="#ECBE6B"
        d="M48.1 11.7a7.3 7.3 0 00-2.4-3.3c.4.6.8 1.2 1 2 1.2 3 .2 6.4-2.4 8.3L38.8 23a8.2 8.2 0 01-5 1.7H31v1.3h4.2c1.7 0 3.5-.6 4.9-1.7l5.5-4.2c2.6-2 3.6-5.3 2.5-8.3z"
      />
      <path
        fill="#FFD064"
        d="M30.4 38l-2-1.5a3.4 3.4 0 01-1.3-2.7v-6.6h-4.5v6.6c0 1-.5 2-1.3 2.7l-2 1.5a.8.8 0 00.5 1.4h10c.9 0 1.2-1 .6-1.4z"
      />
      <path
        fill="#ECBE6B"
        d="M30.4 38l-2-1.5a3.4 3.4 0 01-1.3-2.7v-6.6h-2.3v6.6c0 1 .5 2 1.3 2.7l2 1.5c.6.5.3 1.4-.5 1.4h2.3c.8 0 1-1 .5-1.4z"
      />
      <path
        fill="#FFE07D"
        d="M37.5 2h-25c-.4 0-.8.4-.8.9v8.9c0 3.8 1 7.5 3 10.8l2.4 3.7a9.3 9.3 0 0015.7 0l2.3-3.7c2.1-3.3 3.2-7 3.2-11V3c0-.5-.4-1-.8-1z"
      />
      <path
        fill="#FFD064"
        d="M37.5 2h-4v4.8c0 3.9-1.1 7.7-3.2 11l-2.4 3.7A9.3 9.3 0 0116.3 25l.8 1.3a9.3 9.3 0 0015.7 0l2.3-3.7c2.1-3.3 3.2-7 3.2-11V3c0-.5-.4-1-.8-1z"
      />
      <path
        fill="#0DC183"
        d="M25 44.9c-4.7 0-9.3-1.4-13.3-4A25.3 25.3 0 013 30.2a.8.8 0 111.4-.7A23 23 0 0025 43.4a23 23 0 0020.7-13.8.8.8 0 011.4.7c-2 4.3-5 8-8.8 10.5-4 2.7-8.6 4.1-13.3 4.1z"
      />
      <path
        fill="#AAD880"
        d="M49 28.5c-.7 2-2.1 3.2-3 2.8-1-.4-1-2.2-.2-4.2a23 23 0 013.6-4.8c.2-.2.6 0 .6.3a23 23 0 01-1 5.9z"
      />
      <path
        fill="#80CB8E"
        d="M49.4 22.3l-1 1.2a17 17 0 01-.8 4.3c-.6 1.3-1.5 2.4-2.3 2.7l.6.8c1 .4 2.4-.9 3.2-2.8a23 23 0 00.9-5.9c0-.3-.4-.5-.6-.3z"
      />
      <path
        fill="#AAD880"
        d="M43.6 32.8c0 2-.7 3.7-1.6 3.7-1 0-1.7-1.6-1.8-3.6 0-1.4.8-4.1 1.2-5.5.1-.3.5-.3.6 0 .6 1.3 1.5 4 1.6 5.4zM38 36.8c.7 1.8.7 3.6-.2 4-.8.3-2.2-.9-3-2.7-.5-1.3-.7-4.1-.8-5.6 0-.3.3-.5.5-.2 1 1 2.9 3.1 3.5 4.5z"
      />
      <path
        fill="#80CB8E"
        d="M38 36.8c-.6-1.4-2.5-3.5-3.5-4.5a.3.3 0 00-.5.2V34c1 1 2 2.4 2.4 3.3.6 1.3.7 2.6.5 3.3.3.2.6.3 1 .1.8-.3.8-2.1 0-4z"
      />
      <path
        fill="#AAD880"
        d="M43 41c-2-.6-3.2-1.9-2.9-2.7.3-1 2-1.1 4-.4 1.3.4 3.6 2.1 4.7 3 .2.2.1.6-.2.6-1.5 0-4.3 0-5.6-.5zM37 45.1c-1.9-.6-3.2-1.9-2.9-2.7.3-1 2.1-1 4-.4 1.4.4 3.6 2.2 4.7 3 .3.3.1.7-.2.7-1.4 0-4.3 0-5.6-.6z"
      />
      <path
        fill="#80CB8E"
        d="M48.8 41c-.5-.4-1.1-1-1.8-1.4-1.5 0-4-.1-5.2-.5a7 7 0 01-1.7-.9c-.3 1 1 2.2 2.9 2.8 1.3.5 4.1.6 5.6.5.3 0 .4-.4.2-.5zM42.8 45L41 43.8c-1.5 0-4 0-5.2-.5a7 7 0 01-1.7-.9c-.3 1 1 2.2 2.9 2.8 1.3.5 4.2.6 5.6.6.3 0 .5-.4.2-.6z"
      />
      <path
        fill="#AAD880"
        d="M1 28.5c.7 2 2.1 3.2 3 2.8 1-.4 1-2.2.2-4.2a23 23 0 00-3.6-4.8.4.4 0 00-.6.3c0 1.5.3 4.5 1 5.9z"
      />
      <path
        fill="#80CB8E"
        d="M4.2 27.1a23 23 0 00-3.6-4.8.4.4 0 00-.6.3l.1 1.5c1 1.2 2.2 2.7 2.6 3.7.6 1.3.7 2.6.4 3.5h1c.9-.4 1-2.2.1-4.2z"
      />
      <path
        fill="#AAD880"
        d="M6.4 32.8c0 2 .7 3.7 1.6 3.7 1 0 1.7-1.6 1.8-3.6 0-1.4-.8-4.1-1.2-5.5a.3.3 0 00-.6 0c-.6 1.3-1.5 4-1.6 5.4z"
      />
      <path
        fill="#80CB8E"
        d="M43.6 32.8c0-1.4-1-4-1.6-5.4a.3.3 0 00-.6 0L41 29c.4 1.3.9 3 1 4 0 1.3-.3 2.5-.9 3.1.3.3.6.5 1 .5.8 0 1.5-1.7 1.5-3.7zM8.6 27.4a.3.3 0 00-.6 0l-.6 1.5c.4 1.4.8 3 .7 4 0 1.4-.4 2.5-.9 3.1.2.3.5.5.8.5 1 0 1.7-1.6 1.8-3.6 0-1.4-.8-4.1-1.2-5.5z"
      />
      <path
        fill="#AAD880"
        d="M12 36.8c-.7 1.8-.7 3.6.2 4 .8.3 2.2-.9 3-2.7.5-1.3.7-4.1.8-5.6 0-.3-.3-.5-.5-.2-1 1-2.9 3.1-3.5 4.5z"
      />
      <path
        fill="#80CB8E"
        d="M15.5 32.3l-1.2 1.2c0 1.4-.3 3-.7 4a5.3 5.3 0 01-2 2.5c0 .3.3.6.6.7.8.4 2.2-.8 3-2.6.5-1.3.7-4.1.8-5.6 0-.3-.3-.5-.5-.2z"
      />
      <path
        fill="#AAD880"
        d="M7 41c2-.6 3.2-1.9 2.9-2.7-.3-1-2-1.1-4-.4-1.3.4-3.6 2.1-4.7 3-.2.2-.1.6.2.6 1.5 0 4.3 0 5.6-.5zM13 45.1c1.9-.6 3.2-1.9 2.9-2.7-.3-1-2.1-1-4-.4-1.4.4-3.6 2.2-4.7 3-.3.3-.1.7.2.7 1.4 0 4.3 0 5.6-.6z"
      />
      <path
        fill="#80CB8E"
        d="M9.9 38.3c-.1-.4-.5-.6-1-.8-.3.8-1.4 1.7-2.9 2.2-.9.3-2.4.4-3.8.4l-1 .9c-.2.1-.1.5.2.5 1.5 0 4.3 0 5.6-.5 2-.6 3.2-1.9 2.9-2.7zM15.9 42.4c-.2-.4-.5-.6-1-.7-.3.7-1.4 1.6-2.9 2-.9.4-2.4.5-3.8.6l-1 .8c-.3.2-.1.6.2.6 1.4 0 4.3 0 5.6-.6 1.9-.6 3.2-1.9 2.9-2.7z"
      />
      <path
        fill="#ECBE6B"
        d="M24.8 20.2a5.6 5.6 0 100-11.2 5.6 5.6 0 000 11.2z"
      />
      <path
        fill="#EAB14D"
        d="M26.9 9.4a5.6 5.6 0 01-7.3 7.3 5.6 5.6 0 107.3-7.3z"
      />
      <path
        fill="#FFE07D"
        d="M25.2 12l.6 1.3s.1.2.3.2l1.3.2c.3 0 .4.4.2.6l-1 1v.3l.1 1.3c0 .3-.2.5-.5.4l-1.2-.7h-.3l-1.2.7c-.3.1-.6-.1-.5-.4l.2-1.3-.1-.4-1-.9a.4.4 0 01.2-.6l1.4-.2.2-.2.6-1.2c.2-.3.6-.3.7 0z"
      />
      <path
        fill="#FFD064"
        d="M27.6 14.3c.2-.2 0-.6-.2-.6l-.5-.1-1.3 1.3c-.1 0-.2.3-.1.4l.2 1.7.5.3c.3.1.6-.1.5-.4l-.2-1.3.1-.4 1-.9z"
      />
      <path
        fill="#407093"
        d="M32.3 48H17.7a.8.8 0 01-.8-.8v-7c0-.4.3-.8.8-.8h14.6c.5 0 .8.4.8.9v6.9c0 .4-.3.8-.8.8z"
      />
      <path
        fill="#365E7D"
        d="M32.3 39.4h-1.6v5.4c0 .4-.3.8-.8.8h-13v1.6c0 .4.3.8.8.8h14.6c.5 0 .8-.4.8-.8v-7c0-.4-.3-.8-.8-.8z"
      />
    </svg>
    <div class="c-finish__title">
      <span v-html="content.title" />
    </div>
    <div class="c-finish__text" v-html="content.text" />
    <a
      v-if="content.button"
      class="c-finish__button btn shadow btn-lg btn-primary"
      :href="content.button.href"
    >
      {{ content.button.text }}
    </a>
  </div>
</template>

<script>
import contentComponent from "@/mixins/content";

export default {
  name: "c-finish",
  mixins: [contentComponent],
};
</script>

<style lang="scss" scoped>
.c-finish {
  background: #fff;
  font-weight: 300;
  padding: 2rem;
  border-radius: 0.5rem;
  max-width: 90%;
  font-size: 1.125rem;
  text-align: center;
  box-shadow: 0px 4px 4px rgba(0, 0, 0, 0.25);

  @include media-breakpoint-down(xl) {
    font-size: 1rem;
    padding: 1.5rem;
  }

  @include media-breakpoint-down(lg) {
    font-size: 0.75rem;
    padding: 1.25rem;
  }

  &__icon {
    width: 50px;
    height: 50px;
    display: block;
    margin: 0 auto 2rem;

    @include media-breakpoint-down(xl) {
      width: 2rem;
      margin: 0 auto 1.5rem;
    }
    @include media-breakpoint-down(lg) {
      width: 1.5rem;
      margin: 0 auto 0.75rem;
    }
  }
  &__title {
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 1.125rem;
    font-weight: bold;
    text-align: center;

    @include media-breakpoint-down(xl) {
      font-size: 1rem;
    }

    @include media-breakpoint-down(lg) {
      font-size: 0.75rem;
    }
  }
  &__text {
    margin: 2rem 0 0;
    text-align: center;

    @include media-breakpoint-down(xl) {
      margin-top: 1.5em;
    }
    @include media-breakpoint-down(lg) {
      margin-top: 0.75em;
    }
  }
  &__button {
    padding: 0.75rem 5rem;
    margin: 1rem auto 0;

    @include media-breakpoint-down(xl) {
      margin-top: 0.75em;
      font-size: 1rem;
    }
    @include media-breakpoint-down(lg) {
      margin-top: 0.5em;
      font-size: 0.75rem;
    }
  }
}
</style>
